import { memo } from 'react';
import { PlainModal, Button, BUTTON_THEMES, ELEMENT_SIZE, LoaderComponent } from 'ht-styleguide';
/* Query */
import useSubscriptionsQueryShow from '@store/queries/subscription/useSubscriptionsQuery.show';

/* Components */
import Either from '@components/Either';

/* Constants */
import { MONTHLY_PLAN_ID } from '@constants/plan';

/* Types */
import { Sku } from 'types/sku.types';
import { TPlansInfo } from 'types/plans.types';
import MainContent from './MainContent';

/* styles */
import styles from './planmodal.module.scss';

/* constants */
const CTA_BUTTON_TEXT = 'Add Membership With This Service';

type PlanModalProps = {
  visible: boolean;
  id?: number;
  sku: Sku;
  plansInfo?: TPlansInfo;
  closePlanModal: BaseAnyFunction;
  addPlan: BaseAnyFunction;
};

const PlanModal = ({ id = MONTHLY_PLAN_ID, sku, visible, closePlanModal, addPlan, plansInfo }: PlanModalProps) => {
  const { isLoading, data: { plan: queryPlan } = {} } = useSubscriptionsQueryShow({ id });

  return (
    <PlainModal
      isVisible={visible}
      hide={closePlanModal}
      onRequestClose={closePlanModal}
      modalClassName={styles.contentModal}
      modalCloseButtonClasses={styles.closeButton}
      elementSize={ELEMENT_SIZE.LARGE}
    >
      <Either condition={isLoading}>
        <div className="planLoadable">
          <LoaderComponent />
          <style jsx>
            {`
              .planLoadable {
                min-height: 400px;
                align-items: center;
                justify-content: center;
                display: flex;
              }
            `}
          </style>
        </div>
        <>
          <MainContent plan={queryPlan} sku={sku} plansInfo={plansInfo} />
          <div className={styles.ctaWrapper}>
            <Button theme={BUTTON_THEMES.PRIMARY} className={styles.ctaButton} onClick={addPlan}>
              {CTA_BUTTON_TEXT}
            </Button>
          </div>
        </>
      </Either>
    </PlainModal>
  );
};

export default memo(PlanModal);
